<template>
  <section class="container" :class="{ showSidebar: $root.showSidebar }">
    <CommonHeader></CommonHeader>
    <el-tabs value="presence" type="border-card" @tab-click="handleClick" ref="presence_mode_tabs">
      <el-tab-pane name="presence" ref="presence_tab">
        <span slot="label">
          <el-dropdown @command="handleCommand"
            :class="{ presenceActive: $root.activeName == 'presence' || $root.activeName == 'chat' || $root.activeName == 'tel' || $root.activeName == 'f2f' }">
            <span class="el-dropdown-link">{{ $root.htmlConst.cons_231_realtime_mode }}</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-bind:disabled="$root.isDataLoading" command="presence">{{
                $root.htmlConst.cons_101_presence_tab }}</el-dropdown-item>
              <el-dropdown-item v-bind:disabled="$root.isDataLoading" command="chat">{{
                $root.htmlConst.cons_102_chat_tab }}</el-dropdown-item>
              <el-dropdown-item v-bind:disabled="$root.isDataLoading" command="mail" disabled>{{
                $root.htmlConst.cons_102_mail_tab }}</el-dropdown-item>
              <el-dropdown-item v-bind:disabled="$root.isDataLoading" command="tel">{{ $root.htmlConst.cons_101_tel_tab
                }}</el-dropdown-item>
              <el-dropdown-item v-bind:disabled="$root.isDataLoading" command="f2f">{{ $root.htmlConst.cons_101_f2f_tab
                }}</el-dropdown-item>
              <!-- <el-dropdown-item command="picmap" disabled>{{$root.htmlConst.cons_231_picmap_mode}}</el-dropdown-item> -->
              <!-- <el-dropdown-item>{{$root.htmlConst.cons_231_locationmap_mode}}</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
        </span>
        <el-main v-show="$root.activeName != 'history' && $root.activeName != 'voice_log' && $root.activeName != 'mail'">
          <RealTimePresenceSettingMenu v-if="$root.editMode && $root.activeName == 'presence'">
          </RealTimePresenceSettingMenu>
          <RealTimePresenceMain v-if="$root.activeName == 'presence'"></RealTimePresenceMain>

          <RealTimeChatSettingMenu v-if="$root.editMode && $root.activeName == 'chat'"></RealTimeChatSettingMenu>
          <RealTimeChatMain v-if="$root.activeName == 'chat'"></RealTimeChatMain>

          <RealTimeTelSettingMenu v-if="$root.editMode && $root.activeName == 'tel'"></RealTimeTelSettingMenu>
          <RealTimeTelMain v-if="$root.activeName == 'tel'"></RealTimeTelMain>

          <RealTimeF2FSettingMenu v-if="$root.editMode && $root.activeName == 'f2f'"></RealTimeF2FSettingMenu>
          <RealTimeF2FMain v-if="$root.activeName == 'f2f'"></RealTimeF2FMain>

          <PicMapHeaderMenu v-if="$root.activeName == 'picmap'"></PicMapHeaderMenu>

        </el-main>
        <div v-if="$root.activeName == 'mail'"></div>
      </el-tab-pane>

      <!-- <el-tab-pane :label="$root.htmlConst.cons_231_locationmap_mode" name="locationmap" ref="locationmap_tab" disabled>
      </el-tab-pane>
      <el-tab-pane :label="$root.htmlConst.cons_231_picmap_mode" name="picmap" ref="picmap_tab" disabled>
        <el-main>
          <PicMapHeaderMenu></PicMapHeaderMenu>
        </el-main>
      </el-tab-pane> -->

      <el-tab-pane :label="$root.htmlConst.cons_243_voice_log_tab" name="voice_log" ref="voice_log_tab">
        <WavView v-if="$root.activeName == 'voice_log'" ref="wavView"></WavView>
      </el-tab-pane>
      <el-tab-pane :label="$root.htmlConst.cons_201_history_tab" name="history" ref="history_tab">
        <!-- <span slot="label">
           <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">{{$root.htmlConst.cons_201_history_tab}}</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item disabled>{{$root.htmlConst.cons_242_response_score_tab}}</el-dropdown-item>
              <el-dropdown-item command="voice_log">{{$root.htmlConst.cons_243_voice_log_tab}}</el-dropdown-item>
              <el-dropdown-item command="history">{{$root.htmlConst.cons_244_insight_report_tab}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span> -->
        <!-- <el-main style="background: #94e3ff; padding: 13px 10px 0px 10px"> -->
        <!-- <el-main style="padding: 13px 10px 0px 10px" v-show="$root.activeName == 'history'">
          <transition enter-active-class="animated slideInLeft" leave-active-class="animated slideOutLeft"
            :duration="300" mode="out-in">
            <keep-alive>
              <HistorySettingMenu v-if="$root.editMode"></HistorySettingMenu>
              <HistoryHeaderMenu v-else></HistoryHeaderMenu>
            </keep-alive>
          </transition>
        </el-main> -->
        <el-main style="padding: 13px 10px 0px 10px; position: relative;" v-show="$root.activeName == 'history'">
          <!-- HistoryHeaderMenu 始终显示 -->
          <HistoryHeaderMenu></HistoryHeaderMenu>
          <!-- HistorySettingMenu 固定在右侧 -->
          <!-- <div v-if="$root.editMode && $root.activeName == 'history'" class="history-setting-menu-container">
            <HistorySettingMenu></HistorySettingMenu>
          </div> -->
        </el-main>
        <el-main :style="{ 'height': $root.historyChatHeight }" v-show="$root.activeName == 'history'">
          <router-view></router-view>
        </el-main>
        <!-- <el-main v-show="$root.activeName == 'voice_log'">
          <WavView v-show="$root.activeName == 'voice_log'"></WavView>
        </el-main> -->
      </el-tab-pane>

    </el-tabs>
    <!-- ==========================================
         修正日時: 2026-01-26
         修正内容: ソフトフォン（el-drawer）の表示制御
                   - 外側クリックでは閉じない。閉じるはソフトフォン内の閉じるボタンのみ
                   - 背面の画面をクリックできるように pointer-events で制御（bodyクラスで制御）
                   - @close はコメントアウト済み（下記参照）
         ========================================== -->
    <!-- @close="$store.dispatch('phone/setShowPhone', false)" をコメントアウト -->
    <!-- <el-drawer :with-header="false" :modal="false" :show-close="false" :size="350" :visible="showPhone" @close="$store.dispatch('phone/setShowPhone', false)"> -->
    <el-drawer
      :with-header="false"
      :modal="false"
      :show-close="false"
      :size="350"
      :visible="showPhone"
      :custom-class="phoneDrawerClass"
      :style="{ 
        right: phoneDrawerOffset + 'px',
        zIndex: phoneDrawerZIndex 
      }"
    >
      <Phone @collapse-change="handlePhoneCollapseChange"></Phone>
    </el-drawer>
    <!-- モニタリング停止確認ダイアログ -->
    <el-dialog
      title="確認"
      :visible.sync="$store.state.phone.showStopMonitoringConfirmDialog"
      width="30%"
    >
      <span>ダッシュボードでのモニタリングを停止してもよろしいですか？</span>
      <span slot="footer">
        <el-button class="is-red" @click="handleStopMonitoringConfirmOkClick">
          はい
        </el-button>
        <el-button class="is-blue" @click="handleStopMonitoringConfirmCancelClick">
          いいえ
        </el-button>
      </span>
    </el-dialog>
    <el-drawer
      :visible="$root.showHistorySetting && $root.activeName == 'history'"
      direction="rtl"
      :size="350"
      :custom-class="HistorySettingDrawerClass"
      :modal="false"
      :with-header="false">
      <HistorySettingMenu @collapse-change="handleHistorySettingCollapseChange"></HistorySettingMenu>
    </el-drawer>
  </section>
</template>

<script>
// @ is an alias to /src
import CommonHeader from "@/components/CommonHeader.vue";
import PicMapHeaderMenu from "@/components/PicMapHeaderMenu.vue";
import HistoryHeaderMenu from "@/components/HistoryHeaderMenu.vue";
import HistorySettingMenu from "@/components/HistorySettingMenu.vue";
import RealTimePresenceSettingMenu from "@/components/RealTimePresenceSettingMenu.vue";
import RealTimeChatSettingMenu from "@/components/RealTimeChatSettingMenu.vue";
import RealTimeTelSettingMenu from "@/components/RealTimeTelSettingMenu.vue";
import RealTimeF2FSettingMenu from "@/components/RealTimeF2FSettingMenu.vue";
import RealTimePresenceMain from "@/components/RealTimePresenceMain.vue";
import RealTimeChatMain from "@/components/RealTimeChatMain.vue";
import RealTimeTelMain from "@/components/RealTimeTelMain.vue";
import RealTimeF2FMain from "@/components/RealTimeF2FMain.vue";
import WavView from '@/components/recordingSearch/wavView.vue';
import Phone from "@/components/phone/Phone.vue";
import api from "@/api";

export default {
  components: {
    CommonHeader,
    PicMapHeaderMenu,
    HistoryHeaderMenu,
    HistorySettingMenu,
    RealTimePresenceSettingMenu,
    RealTimeChatSettingMenu,
    RealTimeTelSettingMenu,
    RealTimeF2FSettingMenu,
    RealTimePresenceMain,
    RealTimeChatMain,
    RealTimeTelMain,
    RealTimeF2FMain,
    WavView,
    Phone,
    // HistoryVoiceLogMain,
  },
  computed: {
    showPhone() {
      return this.$store.state.phone.showPhone;
    },
    phoneDrawerOffset() {
      return this.$store.getters['drawer/getDrawerOffset']('phone');
    },
    phoneDrawerZIndex() {
      return this.$store.getters['drawer/getDrawerZIndex']('phone');
    },
    phoneDrawerClass() {
      return this.isPhoneCollapsed ? 'softphone-drawer softphone-drawer--collapsed' : 'softphone-drawer';
    },
    HistorySettingDrawerClass() {
      return this.isHistorySettingCollapsed ? 'history-setting-drawer--collapsed' :'history-setting-drawer'
    }
  },
  // ==========================================
  // 修正日時: 2026-01-26
  // 修正内容: ソフトフォン表示中も背面の画面をクリック可能にする
  //           - showPhoneがtrueのときbodyにphone-drawer-allow-back-clicksを付与
  //           - falseのときクラスを削除（CSSでpointer-eventsを制御）
  // ==========================================
  watch: {
    showPhone(visible) {
      // Update drawer order in Vuex
      this.$store.commit('drawer/updateDrawerOrder', { 
        drawerType: 'phone', 
        isOpen: visible 
      });
      
      if (visible) {
        document.body.classList.add('phone-drawer-allow-back-clicks');
      } else {
        document.body.classList.remove('phone-drawer-allow-back-clicks');
        this.isPhoneCollapsed = false;
      }
    },
    isHistorySettingCollapsed(value){
      if(value) {
        document.body.classList.add('history-setting-drawer-allow-back-clicks');
      }else{
        document.body.classList.remove('history-setting-drawer-allow-back-clicks');
      }
    }
  },
  data() {
    return {
      isPhoneCollapsed: false,
      isHistorySettingCollapsed:false,
    };
  },
  // ==========================================
  // 修正日時: 2026-01-26
  // 修正内容: 画面離脱時にbodyクラスを削除（phone-drawer-allow-back-clicks）
  // ==========================================
  beforeDestroy() {
    document.body.classList.remove('phone-drawer-allow-back-clicks');
  },
  created() {
    console.log('Home component created. Checking authentication status...');
    // let login_id = this.$route.query.login_id;
    // let token = this.$route.query.token;
    // let user_id = this.$route.query.user_id;
    // let app_link = this.$route.query.app_link;
    // if (login_id && token && user_id && app_link) {
    //   sessionStorage.setItem("login_id", login_id);
    //   sessionStorage.setItem("token", token);
    //   sessionStorage.setItem("user_id", user_id);
    //   sessionStorage.setItem("app_link", app_link);
    // }
    // if (this.$route.query.token) {
    //   window.location = app_link;
    // }
  },
  methods: {
    handleClick(tab) {
      if (tab.name == "history") {
        this.$refs.presence_mode_tabs.$children[2].$el.style.display = "inline";
        this.$root.fontColor = "#fff";
        this.$root.headerColor = "#00B2F2";
        let self = this;
        self.$root.activeName = tab.name;
        api.getUserEcharts(self.$root.user.user_id).then(
          (res) => {
            if (res && res.data) {
              const list = res.data.userEcharts;
              if (!Array.isArray(list)) {
                return;
              }
              self.$root.usedChartList = [];
              self.$root.unusedChartList = [];
              for (let echart of list) {
                if (echart.checked_flg) {
                  let usedChart = {
                    name: echart.name,
                    displayName: echart.displayName,
                    index: echart.index,
                    type: echart.echart_type,
                  };
                  self.$root.usedChartList.push(usedChart);
                } else {
                  let unusedChart = {
                    name: echart.name,
                    displayName: echart.displayName,
                    index: echart.index,
                    type: echart.echart_type,
                  };
                  self.$root.unusedChartList.push(unusedChart);
                }
              }
            }
          },
          (err) => {
            console.log(err);
          }
        );
      } else if (tab.name == "presence") {
        this.$root.fontColor = "#fff";
        this.$root.headerColor = "#00B2F2";
        let self = this;
        if (self.$root.activeName == "voice_log" || self.$root.activeName == "history") {
          this.$refs.presence_mode_tabs.$children[1].$el.style.display = "inline";
          this.$refs.presence_mode_tabs.$children[2].$el.style.display = "none";

          document.getElementById("tab-presence").className = "el-tabs__item is-top is-active";
          document.getElementById("tab-history").className = "el-tabs__item is-top";
        }
        self.$root.activeName = tab.name;
        api.changeDashboardType(self.$root.user.user_id, "ALL").then(
          (res) => {
            if (res && res.data) {
              if (this.$root.nameless == "display") {
                this.$root.unusedChartPresenceList = [];
                this.$root.usedChartPresenceList = [
                  {
                    name: "PresenceStatusChart",
                    displayName: "応対稼働状況",
                  },
                  {
                    name: "PresenceModeChart",
                    displayName: "応対モード別稼働状況",
                  },
                  {
                    name: "PresenceNgWordsAlertCount",
                    // displayName: "NGワード（マナー）アラート人数",
                    displayName: "要注意アラート件数",
                  },
                  {
                    name: "PresenceLongTimeAlertCount",
                    displayName: "長時間応対アラート件数",
                  },
                  {
                    name: "PresenceSupervisorHelpAlertCount",
                    displayName: this.$root.htmlConst.cons_107_sv_header,
                  },
                  // {
                  //   name: "SuspectedAlertCount",
                  //   displayName: this.$root.htmlConst.cons_108_claim_header,
                  // },
                  // {
                  //   name: "PersonConfirmAlertCount",
                  //   displayName: this.$root.htmlConst.cons_109_annoyances_header,
                  // },
                  // {
                  //   name: "ForecastAlertCount",
                  //   displayName: this.$root.htmlConst.cons_110_hitch_header,
                  // },
                ];
              } else {
                this.$root.unusedChartPresenceList = [
                  {
                    name: "PersonConfirmAlertCount",
                    displayName: this.$root.htmlConst.cons_109_annoyances_header,
                  },
                ];
                this.$root.usedChartPresenceList = [
                  {
                    name: "PresenceStatusChart",
                    displayName: "応対稼働状況",
                  },
                  {
                    name: "PresenceModeChart",
                    displayName: "応対モード別稼働状況",
                  },
                  {
                    name: "PresenceNgWordsAlertCount",
                    // displayName: "NGワード（マナー）アラート人数",
                    displayName: "要注意アラート件数",
                  },
                  {
                    name: "PresenceLongTimeAlertCount",
                    displayName: "長時間応対アラート件数",
                  },
                  {
                    name: "PresenceSupervisorHelpAlertCount",
                    displayName: this.$root.htmlConst.cons_107_sv_header,
                  },
                  // {
                  //   name: "SuspectedAlertCount",
                  //   displayName: this.$root.htmlConst.cons_108_claim_header,
                  // },
                  // {
                  //   name: "ForecastAlertCount",
                  //   displayName: this.$root.htmlConst.cons_110_hitch_header,
                  // },
                ];
              }
              if (localStorage.getItem('usedChartPresenceList')) { // 处理保存问题
                let localConfig = JSON.parse(localStorage.getItem('usedChartPresenceList'))
                this.$root.usedChartPresenceList = this.$root.usedChartPresenceList.filter(item => localConfig.filter(ele => ele.name == item.name).length > 0)
                this.$root.unusedChartPresenceList = this.$root.usedChartPresenceList.filter(item => !localConfig.filter(ele => ele.name == item.name).length > 0)
              }
            }
          },
          (err) => {
            console.log(err);
          }
        );
      } else if (tab.name == "voice_log") {
        this.$root.activeName = tab.name;
        // タブクリック時は常に最新の検索結果に更新する
        this.$nextTick(() => {
          if (this.$refs.wavView && typeof this.$refs.wavView.search === "function") {
            this.$refs.wavView.search();
          }
        });
      }
    },
    handleCommand(command) {

      if ((this.$root.activeName == "history" || this.$root.activeName == "voice_log") && (command == "presence" || command == "chat" || command == "tel" || command == "f2f" || command == "picmap")) {
        this.$refs.presence_mode_tabs.$children[1].$el.style.display = "inline";
        this.$refs.presence_mode_tabs.$children[2].$el.style.display = "none";

        document.getElementById("tab-presence").className = "el-tabs__item is-top is-active";
        document.getElementById("tab-history").className = "el-tabs__item is-top";
      }

      if ((this.$root.activeName == "presence" || this.$root.activeName == "chat" || this.$root.activeName == "tel" || this.$root.activeName == "f2f" || this.$root.activeName == "picmap") && (command == "voice_log" || command == "history")) {
        this.$refs.presence_mode_tabs.$children[1].$el.style.display = "none";
        this.$refs.presence_mode_tabs.$children[2].$el.style.display = "inline";

        document.getElementById("tab-history").className = "el-tabs__item is-top is-active";
        document.getElementById("tab-presence").className = "el-tabs__item is-top";
      }

      if (command == "presence") {
        this.$root.fontColor = "#fff";
        this.$root.headerColor = "#00B2F2";
        let self = this;
        self.$root.activeName = command;
        api.changeDashboardType(self.$root.user.user_id, "ALL").then(
          (res) => {
            if (res && res.data) {
              if (this.$root.nameless == "display") {
                this.$root.unusedChartPresenceList = [];
                this.$root.usedChartPresenceList = [
                  {
                    name: "PresenceStatusChart",
                    displayName: "応対稼働状況",
                  },
                  {
                    name: "PresenceModeChart",
                    displayName: "応対モード別稼働状況",
                  },
                  {
                    name: "PresenceNgWordsAlertCount",
                    // displayName: "NGワード（マナー）アラート人数",
                    displayName: "要注意アラート件数",
                  },
                  {
                    name: "PresenceLongTimeAlertCount",
                    displayName: "長時間応対アラート件数",
                  },
                  {
                    name: "PresenceSupervisorHelpAlertCount",
                    displayName: this.$root.htmlConst.cons_107_sv_header,
                  },
                  // {
                  //   name: "SuspectedAlertCount",
                  //   displayName: this.$root.htmlConst.cons_108_claim_header,
                  // },
                  // {
                  //   name: "PersonConfirmAlertCount",
                  //   displayName: this.$root.htmlConst.cons_109_annoyances_header,
                  // },
                  // {
                  //   name: "ForecastAlertCount",
                  //   displayName: this.$root.htmlConst.cons_110_hitch_header,
                  // },
                ];
              } else {
                this.$root.unusedChartPresenceList = [
                  {
                    name: "PersonConfirmAlertCount",
                    displayName: this.$root.htmlConst.cons_109_annoyances_header,
                  },
                ];
                this.$root.usedChartPresenceList = [
                  {
                    name: "PresenceStatusChart",
                    displayName: "応対稼働状況",
                  },
                  {
                    name: "PresenceModeChart",
                    displayName: "応対モード別稼働状況",
                  },
                  {
                    name: "PresenceNgWordsAlertCount",
                    // displayName: "NGワード（マナー）アラート人数",
                    displayName: "要注意アラート件数",
                  },
                  {
                    name: "PresenceLongTimeAlertCount",
                    displayName: "長時間応対アラート件数",
                  },
                  {
                    name: "PresenceSupervisorHelpAlertCount",
                    displayName: this.$root.htmlConst.cons_107_sv_header,
                  },
                  // {
                  //   name: "SuspectedAlertCount",
                  //   displayName: this.$root.htmlConst.cons_108_claim_header,
                  // },
                  // {
                  //   name: "ForecastAlertCount",
                  //   displayName: this.$root.htmlConst.cons_110_hitch_header,
                  // },
                ];
              }
              if (localStorage.getItem('usedChartPresenceList')) {
                let localConfig = JSON.parse(localStorage.getItem('usedChartPresenceList'))
                this.$root.unusedChartPresenceList = this.$root.usedChartPresenceList.filter(item => localConfig.filter(ele => ele.name == item.name).length == 0)
                this.$root.usedChartPresenceList = this.$root.usedChartPresenceList.filter(item => localConfig.filter(ele => ele.name == item.name).length > 0)
              }
            }
          },
          (err) => {
            console.log(err);
          }
        );
      } else if (command == "chat") {
        this.$root.fontColor = "#125478";
        this.$root.headerColor = "#94E3FF";
        let self = this;
        self.$root.activeName = command;
        api.changeDashboardType(self.$root.user.user_id, "MANUAL_CHAT_MODE").then(
          (res) => {
            if (res && res.data) {
              this.$root.unusedChartChatList = [];
              this.$root.usedChartChatList = [
                {
                  name: "ChatPersonStatusChart",
                  displayName: "応対稼働状況 - のべ人",
                },
                {
                  name: "ChatStatusChart",
                  displayName: "応対稼働状況 - 人",
                },
                {
                  name: "ChatAnswerStatusChart",
                  displayName: "応対ステータス状況",
                },
                {
                  name: "ChatNgWordsAlertCount",
                  displayName: this.$root.htmlConst.cons_105_ngword_header,
                },
                {
                  name: "ChatSupervisorHelpAlertCount",
                  displayName: this.$root.htmlConst.cons_107_sv_header,
                },
              ];
              if (localStorage.getItem('usedChartChatList')) {
                let localConfig = JSON.parse(localStorage.getItem('usedChartChatList'))
                this.$root.unusedChartChatList = this.$root.usedChartChatList.filter(item => localConfig.filter(ele => ele.name == item.name).length == 0)
                this.$root.usedChartChatList = this.$root.usedChartChatList.filter(item => localConfig.filter(ele => ele.name == item.name).length > 0)
              }
            }
          },
          (err) => {
            console.log(err);
          }
        );
      } else if (command == "tel") {
        this.$root.fontColor = "#fff";
        this.$root.headerColor = "#55BFE7";
        let self = this;
        self.$root.activeName = command;
        api.changeDashboardType(self.$root.user.user_id, "NEXMO_ASTERISK_PBX_MODE").then(
          (res) => {
            if (res && res.data) {
              if (this.$root.nameless == "display") {
                this.$root.unusedChartTelList = [];
                this.$root.usedChartTelList = [
                  {
                    name: "TelStatusChart",
                    displayName: this.$root.htmlConst.cons_103_tel_header,
                  },
                  {
                    name: "TelReleaseStatusChart",
                    displayName: this.$root.htmlConst.cons_104_abandon_header,
                  },
                  {
                    name: "TelNgWordsAlertCount",
                    displayName: this.$root.htmlConst.cons_105_ngword_header,
                  },
                  {
                    name: "TelLongTimeAlertCount",
                    displayName: this.$root.htmlConst.cons_106_longtime_header,
                  },
                  {
                    name: "TelSupervisorHelpAlertCount",
                    displayName: this.$root.htmlConst.cons_107_sv_header,
                  },
                ];
              } else {
                this.$root.unusedChartTelList = [
                  {
                    name: "PersonConfirmAlertCount",
                    displayName: this.$root.htmlConst.cons_109_annoyances_header,
                  },
                ];
                this.$root.usedChartTelList = [
                  {
                    name: "TelStatusChart",
                    displayName: this.$root.htmlConst.cons_103_tel_header,
                  },
                  {
                    name: "TelReleaseStatusChart",
                    displayName: this.$root.htmlConst.cons_104_abandon_header,
                  },
                  {
                    name: "TelNgWordsAlertCount",
                    displayName: this.$root.htmlConst.cons_105_ngword_header,
                  },
                  {
                    name: "TelLongTimeAlertCount",
                    displayName: this.$root.htmlConst.cons_106_longtime_header,
                  },
                  {
                    name: "TelSupervisorHelpAlertCount",
                    displayName: this.$root.htmlConst.cons_107_sv_header,
                  },
                ];
              }
              if (localStorage.getItem('usedChartTelList')) {
                let localConfig = JSON.parse(localStorage.getItem('usedChartTelList'))
                this.$root.unusedChartTelList = this.$root.usedChartTelList.filter(item => localConfig.filter(ele => ele.name == item.name).length == 0)
                this.$root.usedChartTelList = this.$root.usedChartTelList.filter(item => localConfig.filter(ele => ele.name == item.name).length > 0)
              }
            }
          },
          (err) => {
            console.log(err);
          }
        );
      } else if (command == "f2f") {
        this.$root.fontColor = "#fff";
        this.$root.headerColor = "#0086B5";
        let self = this;
        self.$root.activeName = command;
        api.changeDashboardType(self.$root.user.user_id, "STAND_MIC_MODE").then(
          (res) => {
            if (res && res.data) {
              this.$root.unusedChartF2FList = [];
              this.$root.usedChartF2FList = [
                {
                  name: "F2FStatusChart",
                  displayName: this.$root.htmlConst.cons_102_f2f_header,
                },
                {
                  name: "F2FNgWordsAlertCount",
                  displayName: this.$root.htmlConst.cons_105_ngword_header,
                },
                {
                  name: "F2FSupervisorHelpAlertCount",
                  displayName: this.$root.htmlConst.cons_107_sv_header,
                },
              ];
              if (localStorage.getItem('usedChartF2FList')) {
                let localConfig = JSON.parse(localStorage.getItem('usedChartF2FList'))
                this.$root.unusedChartF2FList = this.$root.usedChartF2FList.filter(item => localConfig.filter(ele => ele.name == item.name).length == 0)
                this.$root.usedChartF2FList = this.$root.usedChartF2FList.filter(item => localConfig.filter(ele => ele.name == item.name).length > 0)
              }
            }
          },
          (err) => {
            console.log(err);
          }
        );
      } else if (command == "voice_log") {
        this.$root.fontColor = "#fff";
        this.$root.headerColor = "#00B2F2";
        let self = this;
        self.$root.activeName = command;
      } else if (command == "history") {
        this.$root.fontColor = "#fff";
        this.$root.headerColor = "#00B2F2";
        let self = this;
        self.$root.activeName = command;
        api.getUserEcharts(self.$root.user.user_id).then(
          (res) => {
            if (res && res.data) {
              const list = res.data.userEcharts;
              if (!Array.isArray(list)) {
                return;
              }
              self.$root.usedChartList = [];
              self.$root.unusedChartList = [];
              for (let echart of list) {
                if (echart.checked_flg) {
                  let usedChart = {
                    name: echart.name,
                    displayName: echart.displayName,
                    index: echart.index,
                    type: echart.echart_type,
                  };
                  self.$root.usedChartList.push(usedChart);
                } else {
                  let unusedChart = {
                    name: echart.name,
                    displayName: echart.displayName,
                    index: echart.index,
                    type: echart.echart_type,
                  };
                  self.$root.unusedChartList.push(unusedChart);
                }
              }
            }
          },
          (err) => {
            console.log(err);
          }
        );
      } else if (command == "picmap") {
        this.$root.fontColor = "#fff";
        this.$root.headerColor = "#00B2F2";
        let self = this;
        self.$root.activeName = command;
      } else if (command == 'mail') {
        this.$root.fontColor = "#fff";
        this.$root.headerColor = "#00B2F2";
        let self = this;
        self.$root.activeName = command;
      }
    },
    handleStopMonitoringConfirmOkClick() {
      this.$store.commit('phone/updateShowStopMonitoringConfirmDialog', {showStopMonitoringConfirmDialog: false, stopMonitoring: true})
    },
    handleStopMonitoringConfirmCancelClick() {
      this.$store.commit('phone/updateShowStopMonitoringConfirmDialog', {showStopMonitoringConfirmDialog: false});
      this.$store.commit('phone/updateStopMonitoringTrigger', '');
      this.$store.commit('phone/updateLineNumber', '');
    },
    handlePhoneCollapseChange(collapsed) {
      this.isPhoneCollapsed = collapsed;
    },
    handleHistorySettingCollapseChange(collapsed){
      this.isHistorySettingCollapsed = collapsed
    },
  },
};
</script>

<style>
#tab-history,
#tab-voice_log {
  color: #606266
}

.el-dropdown-link:hover,
.presenceActive {
  color: #409EFF;
}

.el-tabs__item.is-active {
  color: #409EFF !important;
}

.el-tabs__item {
  font-weight: bold;
  padding: 1px 20px;
}

#tab-presence {
  margin-left: 14px;
  /* width: 180px; */
  text-align: center;
}

#tab-history {
  width: 180px;
  text-align: center;
}

.el-tabs--border-card>.el-tabs__header {
  position: fixed;
  z-index: 100;
  top: 46px;
  width: 100%;
  /* text-align: center; */
}

.el-tabs--border-card>.el-tabs__content {
  margin-top: 70px;
  padding: 0;
}

.el-tabs__item {
  /* padding: 1px 10px 1px 10px; */
}

.el-tabs--left.el-tabs--border-card .el-tabs__item.is-left {
  height: 46%;
  float: left;
  align-items: center;
  display: flex;
  flex-flow: column;
}

.el-tabs__nav {
  width: 100%;
}

.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/* ==========================================
   修正日時: 2026-01-26
   修正内容: ソフトフォン表示中も背面の画面をクリック可能にする
             - el-drawerはappendToBodyでbody直下に描画されるためbodyクラスで制御
             - wrapperはpointer-events:noneでクリック透過、パネルのみpointer-events:auto
   ========================================== */
body.phone-drawer-allow-back-clicks .el-drawer__wrapper {
  pointer-events: none;
}
body.phone-drawer-allow-back-clicks .el-drawer {
  pointer-events: auto;
}

body.phone-drawer-allow-back-clicks .softphone-drawer {
  transition: height 0.22s ease, min-height 0.22s ease;
}

body.phone-drawer-allow-back-clicks .softphone-drawer--collapsed {
  height: 50px !important;
  min-height: 50px !important;
  overflow: hidden;
}

body.phone-drawer-allow-back-clicks .softphone-drawer--collapsed .el-drawer__body {
  padding: 0;
  overflow: hidden;
}

.history-setting-drawer {
  top: 46px !important; /* header (46px) + tabs header (70px) */
  height: calc(100vh - 46px) !important;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
}
.history-setting-drawer--collapsed{
  top: 46px !important; /* header (46px) + tabs header (70px) */
  height: 41px!important;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}
body.history-setting-drawer-allow-back-clicks .el-drawer__wrapper {
  pointer-events: none;
}
body.history-setting-drawer-allow-back-clicks .el-drawer {
  pointer-events: auto;
}
body.history-setting-drawer-allow-back-clicks .history-setting-drawer--collapsed .el-drawer__body {
  padding: 0;
  overflow: hidden;
}
</style>
